module.exports = __webpack_public_path__ + "media/images/mac_banner@3x-1aab6e699106e81ef1bd817bfe4343ac.png";